import type { MailListItemProps } from '../components/MailListItem';
import { type PropertyIcons } from '../schema/PropertyIcons';

export const getPropertyIcons = (mailListItemProps: MailListItemProps): PropertyIcons[] => {
    const { importance, hasAttachment, effectiveMentioned, likeCount } = mailListItemProps;
    // Note that we only use current folder's properties for computing the icon
    // Also the icons are added in the order in which we display them (from left to right).
    const propertyIcons: PropertyIcons[] = [];

    if (importance === 'Low') {
        propertyIcons.push(38);
    } else if (importance === 'High') {
        propertyIcons.push(1);
    }

    if (hasAttachment) {
        propertyIcons.push(2);
    }

    if (effectiveMentioned) {
        propertyIcons.push(35);
    }

    if (likeCount > 0) {
        propertyIcons.push(33);
    }

    return propertyIcons;
};
